import { createSlice } from "@reduxjs/toolkit";
import Auth from "ts/api/auth";
import { fetchUser } from "./actions";
import { resetUser } from "./resetUser";

const initialState: Auth = {
  id: "",
  email: "",
  role: null,
  hasPassword: false,
};

const userSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUser.fulfilled, (state, { payload }) => payload);
    builder.addCase(resetUser, () => ({
      id: "",
      email: "",
      role: null,
      hasPassword: false,
    }));
  },
});

export default userSlice.reducer;
